import React, { useContext } from 'react';
import { Container, Stack, ThemeProvider, Typography } from '@mui/material';
import ProductManagementTable from './ProductManagementTable';
import MainBreadCrumb from '../../wrappers/breadcrumb/MainBreadCrumb';
import { newTheme } from '../../components/theme/theme';
import { AuthContext } from '../../common/Auth';
import { useThemeSettings } from '../../layouts/state/useThemeSettings';

export default function ProductManagementPage() {
  const { settingData } = useContext(AuthContext);
  const { themedefaultColor, themedefaultTextColor, defaultFont } = useThemeSettings({
    settingData,
  });

  return (
    <ThemeProvider
      theme={newTheme({ themedefaultColor, themedefaultTextColor, fontFamily: defaultFont })}
    >
      <MainBreadCrumb />
      <Container maxWidth="xl">
        <Stack>
          <Typography variant='h4' gutterBottom>Products</Typography>
          <ProductManagementTable />
        </Stack>
      </Container>
    </ThemeProvider>
  );
}
